// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"861":"2dbfa30b","4453":"9d6be40b","5478":"2dbfa30b","7873":"2dbfa30b"}[chunkId] + ".chunk.css";
};